<template>
  <div style="margin-top:10px">
    <div class="platform_div">
      <div class="platform_common_title">线下成本发票审核列表</div>
      <div>
        <el-date-picker class="picker_input" @change="init(1)" v-model="month" type="month" size="mini" clearable value-format="yyyy-MM" placeholder="所属月份">
        </el-date-picker>
        <label class="picker_name">审核状态：</label>
        <el-select class="picker_input" v-model="status" size='mini' @change="init(1)" clearable filterable placeholder="请选择审核状态">
          <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <template v-if="userInfo.role_id == 10 || userInfo.role_id == 18">
          <el-select v-model="pre_audit_status" @change="init(1)" style="width:150px;margin-right:15px;" size="mini"
            clearable placeholder="财务预审状态">
            <el-option v-for="(item, index) in pre_audit_list" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>
      </div>
    </div>
    <ux-grid class="uxGridBox" ref="plxTable" :height="height" show-footer-overflow="tooltip" show-overflow="tooltip" keep-source :edit-config="{trigger: 'manual', mode: 'row'}" size="mini">
      <ux-table-column v-for="item in columns" :key="item.id" :resizable='true' :field="item.prop" :title="item.label" :width="item.width" show-header-overflow='tooltip' :fixed="item.fixed?item.fixed:''" align="center">
        <template v-slot="{ row }">
          <span>{{row[item.prop]}}</span>
        </template>
      </ux-table-column>
      <ux-table-column :resizable='true' title="预审结果" align="center" minWidth="80" fixed="right" field="describe" v-if="userInfo.role_id == 18 || userInfo.role_id == 10">
        <template v-slot="{ row }">
          <span v-if="row.pre_audit_status == 1" style="color:#00BB5D">通过</span>
          <span v-else-if="row.pre_audit_status == 2" style="color:red">驳回
            <el-popover placement="left-end" title="预审意见" width="400" trigger="hover" :content="row.pre_audit_content">
              <i class="el-icon-view" slot="reference" style="color: #202652;"></i>
            </el-popover>
          </span>
        </template>
      </ux-table-column>
      <ux-table-column :resizable='true' title="审核状态" align="center" minWidth="100" fixed="right" field="describe">
        <template v-slot="{ row }">
          <span v-if="row.status == 1">待媒介审核</span>
          <span v-else-if="row.status == 2">待财务审核</span>
          <span v-else-if="row.status == 3" style="color:red">媒介审核驳回</span>
          <span v-else-if="row.status == 4" style="color:#00BB5D">财务审核通过</span>
          <span v-else-if="row.status == 5" style="color:red">财务审核驳回</span>
        </template>
      </ux-table-column>
      <ux-table-column title="操作" align="center" minWidth="120" fixed="right" field="describe">
        <template v-slot="{ row }">
          <div style="text-align:center">
            <span style="margin-right:5px;color:#5B7BFE;cursor: pointer;" v-if="(userInfo.role_id==13&&row.status==1)||((userInfo.role_id==10 || userInfo.role_id==18)&&row.status==2)" @click="verifyEvent(row)">审核</span>
            <span style="margin-right:5px;color:#f66034;cursor: pointer;" v-if="(userInfo.role_id!=18&&userInfo.role_id!=10&&userInfo.role_id!=13)&&(row.status==1||row.status==2)" @click="delVerifyEvent(row)">撤销</span>
            <span style="margin-right:5px;color:#5B7BFE;cursor: pointer;" @click="downLoadCostApply(row)">下载</span>
          </div>
        </template>
      </ux-table-column>
    </ux-grid>
    <div class="paginationBox" style="height: 30px;">
      <el-pagination small background :current-page="page" :page-size="page_size" @current-change="handleCurrentChange" layout="total, prev, pager, next" :total="total">
      </el-pagination>
    </div>
    <!-- 审核 -->
    <el-dialog title="审核" :visible.sync="verifyFlag" width="30%" :close-on-click-modal='false' center>
      <!-- 财务预审 -->
      <template v-if="userInfo.role_id == 18 && !selectedInfo.pre_audit_status">
        <div class="dialogBox" v-loading='verifyLoading'>
          <div class="dialogitem">
            <label>预审：</label>
            <el-radio-group v-model="preAudit.status">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">驳回</el-radio>
            </el-radio-group>
          </div>
          <div class="dialogitem" style="margin-top:20px">
            <label>预审意见：</label>
            <el-input style="margin-top:10px;width:100%" maxlength="300" type="textarea" :rows="2" placeholder="请输入审核意见" v-model="preAudit.content">
            </el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="preAuditSubmit" size="mini">提交</el-button>
        </span>
      </template>
      <!-- 财务预审结果 -->
      <template v-if="(selectedInfo.pre_audit_status && userInfo.role_id == 18) || userInfo.role_id == 10">
        <div class="dialogitem flex marB10">
          <label>预审：</label>
          <p>{{ selectedInfo.pre_audit_status == 1 ? '通过' : selectedInfo.pre_audit_status == 2 ? '驳回' : '' }}</p>
        </div>
        <div class="dialogitem flex marB10">
          <label>预审意见：</label>
          <p>{{ selectedInfo.pre_audit_content }}</p>
        </div>
      </template>
      <!-- 审核 -->
      <template v-if="userInfo.role_id != 18">
        <div class="dialogBox" v-loading='verifyLoading'>
          <div class="dialogitem">
            <label>审核意见：</label>
            <el-input style="margin-top:10px;width:100%" type="textarea" :rows="2" placeholder="请输入审核意见" v-model="verify_note">
            </el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="costApplyVerifyEvent(1)" size="mini">审核驳回</el-button>
          <el-button type="primary" @click="costApplyVerifyEvent(2)" size="mini">审核通过</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { json2excel } from "@/assets/js/Export/setMethods.js"
export default {
  data () {
    return {
      height: 400,
      columns: [
        { prop: 'id', fixed: 'left', label: '序列号', width: '70' },
        { prop: 'month', fixed: 'left', label: '月份', width: '90' },
        { prop: 'company_name', label: '线下付款公司', width: '100' },
        { prop: 'invoice_date', label: '成本开票日期', width: '100' },
        { prop: 'invoice_money', label: '开票金额', width: '100' },
        { prop: 'apply_user', label: '申请人', width: '100' },
        { prop: 'created_at', label: '申请时间', width: '100' },
        { prop: 'apply_note', label: '申请说明', width: '100' },
        { prop: 'verify_user', label: '媒介审核人', width: '100' },
        { prop: 'verify_at', label: '媒介审核时间', width: '100' },
        { prop: 'verify_note', label: '媒介审核意见', width: '100' },
        { prop: 'verify_cw_user', label: '财务审核人', width: '100' },
        { prop: 'verify_cw_at', label: '财务审核时间', width: '100' },
        { prop: 'verify_cw_note', label: '财务审核意见', width: '100' },
      ],
      page: 1,
      page_size: 30,
      month: '',
      total: 0,
      status: '',
      statusList: [
        { id: '1', name: '待媒介审核' },
        { id: '2', name: '待财务审核' },
        { id: '3', name: '媒介审核驳回' },
        { id: '4', name: '财务审核通过' },
        { id: '5', name: '财务审核驳回' },
      ],
      userInfo: {},
      verifyFlag: false,
      verifyLoading: false,
      verify_note: '',
      verify_id: '',
      preAudit: {//财务预审
        status: '',
        content: ''
      },
      selectedInfo: {},
      pre_audit_status: '',
      pre_audit_list: [
        { label: '待审核', value: 0 },
        { label: '审核通过', value: 1 },
        { label: '审核驳回', value: 2 },
      ]
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
  },
  mounted () {
    this.height = document.documentElement.clientHeight - 195 > 400 ? document.documentElement.clientHeight - 195 : 400
    this.init(1)
  },
  methods: {
    verifyEvent (row) {
      if ((this.userInfo.role_id == 13 && row.status == 1) || ((this.userInfo.role_id == 10 || this.userInfo.role_id == 18) && row.status == 2)) {
        this.verify_id = row.id;
        this.verifyFlag = true

        this.selectedInfo = row;
        this.preAudit.status = row.pre_audit_status;
        this.preAudit.content = row.pre_audit_content;
      }
    },
    /**提交预审 */
    preAuditSubmit(){
      if (this.preAudit.status == '' || !this.preAudit.status) {
        this.$message.warning('请选择预审结果')
        return
      }
      if (this.preAudit.status == 2 && (this.preAudit.content == '' || !this.preAudit.content)) {
        this.$message.warning('请输入审核意见')
        return
      }
      this.$loading(this.$loadingConfig);
      this.$axios.post(this.URL.BASEURL + this.URL.preAuditRecordSave,{
          type: 6,
          data_id_list: [ this.selectedInfo.id ],
          status: this.preAudit.status,
          content: this.preAudit.content,
      }).then((res) => {
          var res=res.data;
          this.$loading(this.$loadingConfig).close();
          if(res&& res.errno == 0){
            this.verifyFlag = false;
            this.init(this.page)
          }else {
            this.$message({
                message: res.err,
                type: 'warning'
            })
          }
      }).catch(()=>{
        this.$loading(this.$loadingConfig).close();
      })
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    init (page) {
      this.page = page ? page : this.page;
      var params = {
        page: this.page,
        pagesize: this.page_size,
        month: this.month,
        status: this.status,
        pre_audit_status: this.pre_audit_status
      }
      this.$loading(this.$loadingConfig);
      this.$axios.get(this.URL.BASEURL + this.URL.offlineCostInvoiceApplyList, {
        params
      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          var data = res.rst;
          this.total = data.pageInfo.total;
          this.datas = data.data // 知道为啥datas不在 data()方法里面定义吗？嘻嘻
          this.$refs.plxTable.reloadData(this.datas)
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    costApplyVerifyEvent (type) {
      var verify_status = '';
      if (type == 1) {//审核驳回
        if (this.userInfo.role_id == 13) {
          verify_status = 3
        }
        if (this.userInfo.role_id == 10) {
          verify_status = 5
        }
      }
      if (type == 2) {//审核通过
        if (this.userInfo.role_id == 13) {
          verify_status = 2
        }
        if (this.userInfo.role_id == 10) {
          verify_status = 4
        }
      }
      if (type == 1 && (this.verify_note == '' || !this.verify_note)) {
        this.$message({
          message: '请输入审核意见',
          type: 'warning'
        })
        return
      }
      this.verifyLoading = true
      this.$axios.post(this.URL.BASEURL + this.URL.offlineCostApplyVerify, {
        status: verify_status,
        id: this.verify_id,
        verify_note: this.verify_note
      }).then((res) => {
        var res = res.data;
        this.verifyLoading = false
        if (res && res.errno == 0) {
          this.verifyFlag = false;
          this.verify_note = '';
          this.verify_id = ''
          this.init(this.page)
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.verifyLoading = false
      })
    },
    delVerifyEvent (row) {//撤销申请
      this.$confirm('确定要撤销此次申请', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$loading(this.$loadingConfig);
        this.$axios.post(this.URL.BASEURL + this.URL.delOfflineCostApply, {
          id: row.id
        }).then((res) => {
          this.$loading(this.$loadingConfig).close();
          var res = res.data;
          if (res && res.errno == 0) {
            this.init(this.page)
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          this.$loading(this.$loadingConfig).close();
        })
      }).catch((action) => {
      });
    },
    downLoadCostApply (row) {//下载
      this.$loading(this.$loadingConfig);
      this.$axios.get(this.URL.BASEURL + this.URL.offlineCostApplyDownload, {
        params: {
          id: row.id
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          var data = res.rst;
          data.forEach((item) => {
            item.rebate = Number(item.rebate)
          });
          var excelDatas = [
            {
              tHeader: ['任务ID', '订单月份', '签约公司', '线下付款公司', '线下付款金额(含税)'],
              filterVal: ['task_id', 'month', 'company', 'offline_subsidy_company', 'rebate'],
              tableDatas: res.rst,
              sheetName: `${row.id} - 线下成本发票审核`
            },
          ]
          json2excel(excelDatas, `${row.id} - 线下成本发票审核`, true, "xlsx")//   引入的函数
          this.$loading(this.$loadingConfig).close();
        } else {
          this.$loading(this.$loadingConfig).close();
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close();
      })

    }
  }
}
</script>
<style lang="scss" scoped>
.platform_div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 20px;
  background: #fff;
}
.picker_name {
  font-size: 13px;
  color: #444;
  margin-left: 10px;
}
.picker_input {
  width: 160px;
}
.marB10{
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/examine/offlineCostInvoiceApplyList.vue